// extracted by mini-css-extract-plugin
module.exports = {"ideas":"IdeasView_ideas__144Ro","circularProgress":"IdeasView_circularProgress__3CEmp","iframeStyle":"IdeasView_iframeStyle__2oPuk"};